<template>
    <div class="top-hotel-grid-wrapper">
        <div class="row gap-20 min-height-alt">
            <v-text-field
                    class="col-xss-12 col-xs-12 col-sm-12 col-mdd-12 col-md-12"
                    hide-details
                    prepend-icon="search"
                    placeholder="Buscar Sala.."
                    single-line
                    v-model="search"
            />
            <div class="col-xss-12 col-xs-12 col-sm-6 col-mdd-6 col-md-4" v-if="rooms.length===0"
                 data-match-height="result-grid">
                <div class="hotel-item-grid">
                    <router-link to="/">
                        <div class="image">
                            <img src="../../assets/images/notfound.jpg" alt="Top Destinations">
                        </div>
                        <div class="heading">
                            <div class="raty-wrapper mb-5">
                                <div class="star-rating-12px" data-rating-score="4"></div>
                            </div>
                            <h4>No hay salas de reuniones</h4>
                            <p v-if="$route.params.city===undefined">
                                Cerca de su ubicación
                            </p>
                            <p v-else>
                                En {{$route.params.city}}
                            </p>
                        </div>

                    </router-link>
                </div>
            </div>

            <div class="col-xss-12 col-xs-12 col-sm-6 col-mdd-6 col-md-4" v-for="room in filteredList"
                 data-match-height="result-grid">
                <div class="hotel-item-grid">
                    <router-link v-if="$route.params.checkin === undefined" :to="'/meetingRoom/'+room._id">
                        <div class="image">
                            <img :src="room.headImage" alt="Top Destinations">
                        </div>
                        <div class="heading">
                            <div class="raty-wrapper mb-5">
                                <div class="star-rating-12px" data-rating-score="4"></div>
                            </div>
                            <h4>{{room.name}}</h4>
                            <p v-if="$route.params.city===undefined">
                                <font-awesome-icon style="margin-right: 0.5em;" icon="map-marker-alt"/>
                                {{room.city}}, Spain </br> <span v-if="room.distance!==undefined">A {{room.distance}} de su ubicación</span>
                            </p>
                            <p v-else>
                                <font-awesome-icon style="margin-right: 0.5em;" icon="map-marker-alt"/>
                                Lleida, Spain
                            </p>
                        </div>
                        <div class="content">
                            <div class="row gap-5">
                                <div class="col-xs-6 col-sm-6">
                                    <div class="tripadvisor-module">
                                        <div class="texting">
                                            Excelente
                                        </div>
                                        <div class="hover-underline">324 reviews</div>
                                    </div>
                                </div>
                                <div class="col-xs-6 col-sm-6">
                                    <p class="price"><span class="block">Reserva desde</span><span
                                            class="number">7€</span> / hora</p>
                                </div>
                            </div>
                        </div>
                    </router-link>
                    <router-link v-else :to="'/meetingRoom/'+room._id+'/'+$route.params.checkin">
                        <div class="image">
                            <img :src="room.headImage" alt="Top Destinations">
                        </div>
                        <div class="heading">
                            <div class="raty-wrapper mb-5">
                                <div class="star-rating-12px" data-rating-score="4"></div>
                            </div>
                            <h4>{{room.name}}</h4>
                            <p v-if="$route.params.city===undefined">
                                <font-awesome-icon style="margin-right: 0.5em;" icon="map-marker-alt"/>
                                {{room.city}}, Spain </br> <span v-if="room.distance!==undefined">A {{room.distance}} de su ubicación</span>
                            </p>
                            <p v-else>
                                <font-awesome-icon style="margin-right: 0.5em;" icon="map-marker-alt"/>
                                Lleida, Spain
                            </p>
                        </div>
                        <div class="content">
                            <div class="row gap-5">
                                <div class="col-xs-6 col-sm-6">
                                    <div class="tripadvisor-module">
                                        <div class="texting">
                                            Excelente
                                        </div>
                                        <div class="hover-underline">324 reviews</div>
                                    </div>
                                </div>
                                <div class="col-xs-6 col-sm-6">
                                    <p class="price"><span class="block">Reserva desde</span><span
                                            class="number">7€</span> / hora</p>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'gridResults',
        props: ['rooms'],
        data: function () {
            return {
                search:''
            }
        },
        computed:{
            filteredList() {
                return this.rooms.filter(room => {
                    return room.name.toLowerCase().includes(this.search.toLowerCase())
                })
            }
        }
    }
</script>
<style scoped>
    .texting {
        color: #8ac6c4 !important;
    }

    a:hover {
        color: #868686 !important;
    }
</style>